import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './CallCenterJobCreationForm.module.css'

export interface CallCenterJobCreationFormProps {
  isEmpty: boolean
  children: ReactNode
}

export function CallCenterJobCreationForm({
  isEmpty,
  children,
}: CallCenterJobCreationFormProps) {
  return (
    <div className={styles.root}>
      {children}
      {isEmpty && (
        <div className={styles.placeholder}>No questions available.</div>
      )}
    </div>
  )
}

export interface CallCenterLegendStepContentProps {
  /**
   * The legend selector, or nothing when the workspace has no tax legends.
   */
  children?: ReactNode
}

export function CallCenterLegendStepContent({
  children,
}: CallCenterLegendStepContentProps) {
  return (
    <div className={styles.questionWrapper}>
      <span className={styles.legendNotice}>
        Only tax legends are available for call center submissions.
      </span>
      {children || (
        <div className={styles.placeholder}>
          No tax legends are available for this workspace.
        </div>
      )}
    </div>
  )
}

export interface CallCenterQuestionStepContentProps {
  isRequired: boolean
  children: ReactNode
}

export function CallCenterQuestionStepContent({
  isRequired,
  children,
}: CallCenterQuestionStepContentProps) {
  return (
    <div className={styles.questionWrapper}>
      <span
        className={cx(
          styles.badge,
          isRequired ? styles.requiredBadge : styles.optionalBadge,
        )}
      >
        {isRequired ? 'Required' : 'Optional'}
      </span>
      {children}
    </div>
  )
}
